





















import Vue from "vue";
import Component from "vue-class-component";
import { ToastOptions, ToastService } from "@/services/toast.service";

@Component
export default class Toast extends Vue {
  openSubs: any = null;
  closeSubs: any = null;

  get top() {
    return this.position.indexOf("top") > -1;
  }
  get bottom() {
    return this.position.indexOf("bottom") > -1;
  }
  get left() {
    return this.position.indexOf("start") > -1;
  }
  get right() {
    return this.position.indexOf("end") > -1;
  }
  get centered() {
    return this.position.indexOf("center") > -1;
  }

  transition = "";
  type: string | null = null;
  message = "";
  position = "bottom";
  show = false;
  duration = -1;
  showCloseButton = false;
  closeButtonText = "fechar";

  mounted() {
    if (!this.openSubs)
      this.openSubs = ToastService.registerOnToastOpen(this.receive);
    if (!this.closeSubs)
      this.closeSubs = ToastService.registerOnToastClose(this.close);
  }

  receive(opt: ToastOptions) {
    this.type = opt.type ?? null;
    this.message = opt.message;
    this.position = opt.position ?? "bottom";

    this.showCloseButton = opt.showCloseButton ?? false;
    this.closeButtonText = opt.closeButtonText ?? "fechar";

    this.show = true;

    this.duration = -1;
    if (opt.duration && opt.duration > 0) this.duration = opt.duration;
  }

  close() {
    this.show = false;
  }
}
